import { createElement } from 'react';
import { string, node, bool, oneOfType, number } from 'prop-types';
import { placementPropType } from '../types/props.js';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { b as _objectWithoutPropertiesLoose } from '../chunk-ad6ad343.js';
import 'reakit/Tooltip';
import _Tooltip from './styled.js';

var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return createElement(_Tooltip, props, children);
};

var tooltipPropTypes = {
  className: string,
  children: node.isRequired,
  delay: string,
  duration: string,
  expand: bool,
  gutter: oneOfType([number, string]),
  fade: bool,
  placement: placementPropType,
  slide: bool,
  timing: string
};
Tooltip.propTypes = tooltipPropTypes;
var tooltipDefaultProps = {
  className: undefined,
  delay: undefined,
  duration: '100ms',
  expand: false,
  fade: false,
  gutter: 4,
  placement: 'bottom',
  slide: false,
  timing: 'ease-in-out'
};
Tooltip.defaultProps = tooltipDefaultProps; // @ts-ignore

var C = Tooltip;
export default C;
export { C as Tooltip, tooltipDefaultProps, tooltipPropTypes };